import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import { Link, useNavigate } from "react-router-dom";
import Settings from "@mui/icons-material/Settings";
import TranslateIcon from '@mui/icons-material/Translate';
import Logout from "@mui/icons-material/Logout";
import { Button } from "@mui/material";
import { logout } from "../components/features/auth/authSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

export const MenuList = (props) => {
    const { i18n } = useTranslation(); // Hàm đổi ngôn ngữ
    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang); // Thay đổi ngôn ngữ
        localStorage.setItem("language", lang); // {t('save')} ngôn ngữ vào localStorage
        window.location.reload()
    };
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleLogout = () => {
        dispatch(logout());
    };
    const { t } = useTranslation();

    const { anchorEl, open, ...other } = props;
   
};
